<div class="field-set select-field-set">
  <label label>Selecionar variável</label>

  <app-select-box
    class="select-field"
    [(value)]="fieldSelected"
    (valueChange)="onFieldSelected($event)"
    [items]="fieldsObservable | async"
    displayExpr="alias"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
  ></app-select-box>
</div>

<div class="main-content">
  <div class="row gy-3 gx-0">
    <div class="col-md-4 d-flex">
      <div
        class="descritive-statistics"
        [ngClass]="{ 'mobile-mode': !!(isMobileModeObservable | async) }"
      >
        <div class="table-container">
          <app-scroll-view
            class="scroll-view"
            [vertical]="false"
            [horizontal]="true"
          >
            <table
              class="table-results"
              mat-table
              [dataSource]="descriptiveStatisticsList"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            >
              <ng-container matColumnDef="label">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="table-header-cell descritive-statistic-header"
                >
                  Estatística descritiva
                </th>
                <td mat-cell *matCellDef="let element" class="table-cell">
                  {{ element.label }}
                </td>
              </ng-container>

              <ng-container matColumnDef="value">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="table-header-cell"
                ></th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  class="table-cell align-end-content"
                >
                  {{ element.value | async | number : "0.0-2" }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="descriptiveStatisticsDisplayedColumns"
                class="table-header"
              ></tr>
              <tr
                mat-row
                *matRowDef="
                  let row;
                  columns: descriptiveStatisticsDisplayedColumns
                "
                class="table-row"
              ></tr>
            </table>
          </app-scroll-view>
        </div>
      </div>
    </div>

    <div class="col-md d-flex">
      <div class="table-container">
        <app-scroll-view
          class="scroll-view"
          [vertical]="false"
          [horizontal]="true"
        >
          <table
            class="table-results table-frequency-list"
            mat-table
            [dataSource]="_pagedData"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <ng-container matColumnDef="alias">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="table-header-cell frequency-header-cell"
              >
                Frequências
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="table-cell"
                [title]="element.alias"
              >
                {{ element.alias }}
              </td>
            </ng-container>

            <ng-container matColumnDef="itemsCount">
              <th mat-header-cell *matHeaderCellDef class="table-header-cell">
                Abs
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell">
                {{ element.count | number }}
              </td>
            </ng-container>

            <ng-container matColumnDef="relPercent">
              <th mat-header-cell *matHeaderCellDef class="table-header-cell">
                rel
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell">
                {{
                  element.count / (totalSizeObservable | async)
                    | percent : "1.0-2"
                }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="table-header"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="table-row"
            ></tr>
          </table>
        </app-scroll-view>

        <div class="pagination-row">
          <app-pagination
            [totalCount]="itemList?.length ?? 0"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            (pageIndexChange)="onPageIndexChange($event)"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          ></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
